"use client";

import { useBroadcastChannel } from "@/hooks/use-broadcast-channel";

/**
 * Provider component that sets up BroadcastChannel listeners
 * This should be placed high in the component tree to ensure
 * all tabs receive sign-out events
 */
export function BroadcastChannelProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  // This hook automatically sets up all the necessary listeners
  useBroadcastChannel();

  return <>{children}</>;
}
